import React, { useState } from 'react';
import { Modal, Select, Button, message } from 'antd';
import dayjs from 'dayjs';
import { FAILURE_REASONS } from '../../constants/candidateColumnLabels';

const { Option } = Select;

const FAILURE_REASONS_OPTIONS = Object.entries(FAILURE_REASONS).map(([key, label]) => ({
    value: key,
    label: label
}));

const CompletionModalKanban = ({
    visible,
    onCancel,
    onConfirm,
    loading = false,
    completionType = 'success'
}) => {
    const [failureReason, setFailureReason] = useState(null);

    const handleConfirm = () => {
        if (completionType === 'failure' && !failureReason) {
            message.warning('Пожалуйста, выберите причину провала');
            return;
        }

        const todayDate = dayjs().format('YYYY-MM-DD');

        const completionData = {
            result: completionType,
            completion_work: todayDate,
            ...(completionType === 'failure' && { failure_reason: failureReason })
        };

        onConfirm(completionData);
    };

    const handleCancel = () => {
        setFailureReason(null);
        onCancel();
    };

    const getTitle = () => {
        switch (completionType) {
            case 'success':
                return 'Завершение: Успех';
            case 'failure':
                return 'Завершение: Провал';
            case 'reserve':
                return 'Завершение: Кандидат в резерве';
            default:
                return 'Выберите результат завершения';
        }
    };

    return (
        <Modal
            title={getTitle()}
            visible={visible}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Отмена
                </Button>,
                <Button
                    key="confirm"
                    type="primary"
                    onClick={handleConfirm}
                    loading={loading}
                >
                    Подтвердить
                </Button>
            ]}
            width={500}
        >
            {completionType === 'failure' && (
                <div style={{ marginTop: 16 }}>
                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 'bold' }}>
                        Причина провала:
                    </label>
                    <Select
                        style={{ width: '100%' }}
                        placeholder="Выберите причину провала"
                        value={failureReason}
                        onChange={setFailureReason}
                    >
                        {FAILURE_REASONS_OPTIONS.map(reason => (
                            <Option key={reason.value} value={reason.value}>
                                {reason.label}
                            </Option>
                        ))}
                    </Select>
                </div>
            )}

            {completionType === 'success' && (
                <div style={{ marginTop: 16, textAlign: 'center', color: '#666' }}>
                    <p>Кандидат успешно завершен.</p>
                    <p>Дата завершения будет установлена на сегодня.</p>
                </div>
            )}

            {completionType === 'reserve' && (
                <div style={{ marginTop: 16, textAlign: 'center', color: '#666' }}>
                    <p>Кандидат будет добавлен в резерв.</p>
                    <p>Дата завершения будет установлена на сегодня.</p>
                </div>
            )}
        </Modal>
    );
};

export default CompletionModalKanban;
